<template>
  <div class="row mb-5">
    <div class="col-12 booleanLabel">{{ fieldText }}</div>
    <div class="col-lg-12">
      <div class="row right-buttons-wrapper">
        <div class="col-lg-12">
          <label class="fcs-radio">
            <slot name="left"></slot>
            <span class="checkbox">{{ buttonTextLeft }}</span>
          </label>
        </div>
        <div class="col-lg-12">
          <label class="fcs-radio">
            <slot name="right"></slot>
            <span class="checkbox">{{ buttonTextRight }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fieldText: String,
    buttonTextLeft: String,
    buttonTextRight: String
  }
}
</script>